import type { Router } from "vue-router";
import { usePermissions } from "@/core/composables/usePermissions";
import { normalizeParamId, scrollToHashOrTop } from "./routeUtils";
import { useAppContextStore } from "../store/AppContextStore";

export function setupRouteEffects(router: Router): void {
  router.afterEach((to, from) => {
    if (!to.meta?.restoreHashOnIdChange) return;

    const appContext = useAppContextStore();
    const user = appContext.context.user;

    if (!user?.id) return;

    const { isEmployee } = usePermissions(user);
    if (!isEmployee.value) return;

    if (to.name !== "Resume" || from.name !== "Resume") return;

    const toId = normalizeParamId(to.params.id);
    const fromId = normalizeParamId(from.params.id);
    if (!toId || !fromId || toId === fromId) return;

    void scrollToHashOrTop(to);
  });
}
